module.exports = __webpack_public_path__ + "img/advantage_02.fdf40b4a.png";